import { createFileRoute } from '@tanstack/react-router';
import { KioskExistingPatronFillingExperiencePage } from '../pages';

export interface SearchParams {
  formId?: string;
  packetId?: string;
}

export const Route = createFileRoute('/kiosk/existing-patron_/$locationId')({
  component: KioskExistingPatronFillingExperiencePage,
  validateSearch: (search: SearchParams): SearchParams => {
    return search;
  },
});
